import { render, staticRenderFns } from "./TaskTitle.vue?vue&type=template&id=3018cbb6&scoped=true&"
import script from "./TaskTitle.vue?vue&type=script&lang=js&"
export * from "./TaskTitle.vue?vue&type=script&lang=js&"
import style0 from "./TaskTitle.vue?vue&type=style&index=0&id=3018cbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018cbb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3018cbb6')) {
      api.createRecord('3018cbb6', component.options)
    } else {
      api.reload('3018cbb6', component.options)
    }
    module.hot.accept("./TaskTitle.vue?vue&type=template&id=3018cbb6&scoped=true&", function () {
      api.rerender('3018cbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/TaskTitle.vue"
export default component.exports